import { ColDef, GridOptions } from '@ag-grid-community/core';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LogService } from '@services/log.service';
import { MoveUserService } from '../../services/move-user.service';
@Component({
  selector: 'app-move-users-confirmation-dialog',
  templateUrl: './move-users-confirmation-dialog.component.html',
  styleUrls: ['./move-users-confirmation-dialog.component.css'],
})
export class MoveUsersConfirmationDialogComponent {
  selectedUsers: any[];
  gridOptions: GridOptions;
  columnDefs: ColDef[];

  public defaultColDef: ColDef = {
    resizable: false,
    sortable: false,
    filter: false,
    flex: 1,
    suppressMovable: true,
    suppressMenu: true,
    suppressColumnsToolPanel: true,
    suppressFiltersToolPanel: true,
  };

  explicitConfirmationConfig = {
    explicitConfirmationText: 'Move',
    title: 'MoveForms.UserMove.MoveUsers',
    messages: [
      {
        message: 'MoveForms.UserMove.WarnLeft',
        icon: 'arrow_forward',
        color: 'red',
      },
      {
        message: 'MoveForms.UserMove.WarnRight',
        icon: 'arrow_upward',
        color: 'green',
      },
    ],
    cancelButtonText: 'Dialog.Cancel',
    confirmButtonText: 'MoveForms.UserMove.MoveUsers',
    inputLabelSuffix: 'MoveForms.UserMove.ExplicityConfirmationLabelSuffix',
  };

  showBillableOrgWarning: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      selectedUsers: any[];
      showBillableOrgWarning?: boolean;
    },
    private dialogRef: MatDialogRef<MoveUsersConfirmationDialogComponent>,
    private _ls: LogService,
    private _translate: TranslateService,
  ) {
    this.selectedUsers = data?.selectedUsers || [];
    this.showBillableOrgWarning = data?.showBillableOrgWarning ?? false;
    this.setupGridOptions();
    this.setupColumnDefs();
    this._ls.log(
      'MoveUsersConfirmationDialog initialized with selectedUsers:',
      this.selectedUsers,
    );
  }

  onConfirm(confirmed: boolean) {
    this.dialogRef?.close(confirmed);
  }

  private setupGridOptions() {
    this.gridOptions = {
      rowHeight: 24,
      suppressMovableColumns: true,
      suppressContextMenu: true,
      tooltipShowDelay: 0,
      tooltipMouseTrack: true,
    };
  }

  private setupColumnDefs() {
    const columns = [
      'userName',
      'firstName',
      'lastName',
      'userId',
      'organizationName',
      'billableOrgName',
      'destinationOrgName',
    ];

    this.columnDefs = columns.map((col) => ({
      headerName: this._translate.instant(`MoveForms.General.${col}`),
      field: col,
    }));

    this.columnDefs.push({
      headerName: 'Direction',
      field: 'direction',
      cellRenderer: (params: any) => {
        return `<span class="material-icons" tooltip="${params.data.direction}" style="color: ${MoveUserService.getColorForDirection(
          params.data.direction,
        )};">${MoveUserService.getIconForDirection(
          params.data.direction,
        )}</span>`;
      },
    });
  }
}
